module.exports = __webpack_public_path__ + "static/media/gal0713.578bc6a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal07/gal0713.jpg
// module id = 522
// module chunks = 0